import {
  CustomFormFieldText,
  CustomFormFieldTextInputType,
} from '@src/@data/types/customForms';
import { useMemo } from 'react';
import { FormGroup, Input, Label } from 'reactstrap';

interface CustomFormTextFieldProps {
  field: CustomFormFieldText;
  inputName: string;
  value?: string | number;
  onChangeField: (value: string | number) => void;
}

export const CustomFormTextField: React.FC<CustomFormTextFieldProps> = ({
  field,
  inputName,
  value,
  onChangeField,
}) => {
  const type = useMemo(() => {
    switch (field.inputType) {
      case CustomFormFieldTextInputType.PhoneNumber:
        return 'tel';
      case CustomFormFieldTextInputType.Multiline:
        return 'textarea';
      default:
        return field.inputType;
    }
  }, [field.inputType]);

  return (
    <FormGroup>
      <Label for={inputName}>{field.name}</Label>
      <Input
        id={inputName}
        type={type}
        pattern={field.pattern?.replaceAll('/', '')}
        required={field.mandatory}
        {...(field.inputType === CustomFormFieldTextInputType.Number
          ? {
              min: field.minLength,
              max: field.maxLength,
            }
          : {
              minLength: field.minLength,
              maxLength: field.maxLength,
            })}
        value={value}
        onChange={(e) => onChangeField(e.target.value)}
      />
    </FormGroup>
  );
};
